import React, { useState, useEffect, useContext } from "react";
import logo2 from "../../image/logo2.png";
import ForgetPwd from "../../Login/ForgetPwd/ForgetPwd";
import AuthService from "../../Login/Services/auth.service";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import { CheckAuthAContext } from "../../App";

const LoginAdmin = (props) => {
  const { checkAuthA, setCheckAuthA } = useContext(CheckAuthAContext);
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const [username, setUserName] = useState("");
  const [password, setPassWord] = useState("");
  //error contole
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (AuthService.getCurrentUser()) {
      window.location.replace("/home");
    }
  });
  const healthPro =
    JSON.parse(sessionStorage.getItem("healthId")) &&
    JSON.parse(sessionStorage.getItem("healthId")).id;
  const handleLogin = (e) => {
    e.preventDefault();
    AuthService.login(username, password).then(
      (res) => {
        if (res) {
          //console.log("this is login res", res.role, res);
          res.role == "MEMBRE"
            ? healthPro
              ? window.location.replace("/profile")
              : window.location.replace("/")
            : res.details && res.role == "USER"
            ? window.location.replace("/message")
            : res.role == "ADMIN"
            ? window.location.replace("/formcarander")
            : window.location.replace("/home");
        } else {
          //window.location.replace("/login");
          setUserName("");
          setPassWord("");
          setMessage("votre compte est en cours d'activation !");
          setSeverity("warning");
          setOpen(true);
        }
      },

      (error) => {
        const resMessage =
          (error.res && error.res.data && error.res.data.message) ||
          error.message ||
          error.toString();
        console.log(error.message);
        setMessage("login ou mot de passe est incorrect");
        setSeverity("error");
        setOpen(true);
      }
    );
  };

  //modale forget password in admin
  const [show, setShow] = useState(false);

  const Toggle = () => {
    setShow(false);
  };

  return (
    <>
      <Snackbar open={open} autoHideDuration={8000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <ForgetPwd Show={show} Toggle={Toggle} />
      {checkAuthA && (
        <div className="showcase-form card">
          <form
            action="#"
            className="sign-in-form login"
            style={{ textAlign: "center" }}
          >
            <img src={logo2} width="115px" className="m-auto" />
            <h3>J'ai déja un compte sur Doclic.</h3>

            <Form.Control
              type="text"
              placeholder="Adresse Email"
              value={username}
              onChange={(e) => setUserName(e.target.value)}
            />

            <Form.Control
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassWord(e.target.value)}
              className="mb-2"
            />

            <button className="btn2 home m-auto" onClick={handleLogin}>
              Login
            </button>
            <Link onClick={() => setShow(true)}>Mot de passe Oublie?</Link>
            <p>
              Nouveau Sur Doclic?
              <Link
                onClick={() => {
                  setCheckAuthA(!checkAuthA);
                }}
              >
                S'inscrire
              </Link>
            </p>
          </form>
        </div>
      )}
    </>
  );
};

export default LoginAdmin;
